// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".push-top {\r\n\tmargin-top: 10px;\r\n}\r\n\r\n.add-btn {\r\n\tmargin-right: 15px;\r\n\tmargin-bottom: 5px;\r\n}\r\n", "",{"version":3,"sources":["webpack://src/components/Dialogs/Voice/index.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB","sourcesContent":[".push-top {\r\n\tmargin-top: 10px;\r\n}\r\n\r\n.add-btn {\r\n\tmargin-right: 15px;\r\n\tmargin-bottom: 5px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
